<template>
  <div class="teachersWall" v-if="teacherList.length === 5">
    <!-- <div class="countdown_titlebox_zx">
      <h2 class="countdown_title floatL">名师墙</h2>
    </div>
    <section class="Junior_teacher">
      <div class="teacher_list">
        <div class="teacher_item" v-for="item in teacherList" :key="item.Code">
          <a :href="`http://souke.xdf.cn/Teacher/${soukecityId}-${schoolId}-${item.Code}-0.html`">
            <div class="teacher_img">
              <img class="photo" :src="item.NewLogoUrl?`http://img.xdf.cn/TeacherIMG/${item.NewLogoUrl}`:'http://img.xdf.cn/souke/mobile1/images/teacherImgOneToOne.png'">
            </div>
            <div class="teacher_info">
              <span class="Name">{{ item.Name }}</span>
              <span class="Subject" :title="item.Subject">{{ item.Subject }}</span>
            </div>
          </a>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import { getMiddleTeacher } from 'js/getSoukeData.js'
import { cityFormInfo } from 'js/staticData.js'
export default {
  name: 'Teacher',
  data () {
    return {
      teacherList: []
    }
  },
  computed: {
    soukecityId () {
      return this.$store.state.soukecityId
    },
    schoolId () {
      if (this.$store.state.soukecityId) {
        return cityFormInfo[this.$store.state.soukecityId].schoolId
      }
    }
  },
  watch: {
    soukecityId (newVal) {
      getMiddleTeacher(cityFormInfo[newVal].schoolId, 5).then(response => {
        this.teacherList = response.TeacherList
      })
    }
  },
  mounted () {
    if (this.soukecityId) {
      getMiddleTeacher(cityFormInfo[this.soukecityId].schoolId, 5).then(response => {
        this.teacherList = response.TeacherList
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.teachersWall
  width: 1200px
  margin: 0 auto
  .countdown_titlebox_zx
    border-bottom: 2px solid #a5e1d6
    height: 39px
    line-height: 39px
    width: 100%
    margin: 0 auto
    box-sizing: border-box
    .countdown_title
      width: 176px
      font-size: 18px
      margin-top: 2px
  .Junior_teacher
    .teacher_list
      width: 100%
      height: 180px
      display: flex
      .teacher_item
        flex: 1
        justify-content: center
        align-items: center
        display: flex
        a
          display: flex
          background: #f7f7f7
          width: 228px
          height: 129px
          margin: 0 auto
          border: 1px solid #f7f7f7
          align-items: center
          .teacher_img
            flex: 1
            text-align: center
            .photo
              width: 80px
              border-radius: 10px
              box-shadow: 2px 2px 5px #ccc
          .teacher_info
            flex: 1
            overflow: hidden
            span
              display: flex
              flex-direction: column
              flex: 1
              align-items: center
            .Name
              font-size: 18px
              color: $themeColor
              max-height: 26px
              line-height: 26px
            .Subject
              color: #adb2b2
              max-height: 40px
              line-height: 20px
              text-align:center
              overflow: hidden
              padding: 0 4px
              display: block
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Teacher.vue